var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-title",class:{
      'is-h1':_vm.type === 'h1',
      'is-h2':_vm.type === 'h2',
      'is-back': _vm.type === 'back'
    },on:{"click":function($event){$event.stopPropagation();_vm._click($event)}}},[_c('h1',{staticClass:"mc-title__h1"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-title.vue